import { NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'alert-note',
    template: `

    <div class="flex flex-col p-4 my-8 border-s-8 border rounded-md  max-w-full border-primary">
        <div class="flex items-center">
            <mat-icon [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
            <span class="text-base uppercase font-semibold text-primary leading-5 ml-2">AVVISO</span>
        </div>
        <div class="mt-2 text-base text-start justify-center text-secondary">{{props.description}}</div>

    </div>

  `,
    standalone: true,
    imports: [FormlyModule, MatIconModule]
})
export class AlertNoteComponent extends FieldWrapper implements OnInit{

  pagamentiTotali:number = 0;

  ngOnInit(): void {
    this.pagamentiTotali = this.model?.pagamenti?.length || 0
  }


}
